module.exports = __webpack_public_path__ + "img/title.45ae6923.jpg";